import { getJSON, postJSON } from './util';

export const READINGS = {
    fetchSampleInterps: function(product_result_uuid) {
        return getJSON(`/api/product/sample_reading/${product_result_uuid}`, {});
    },
    submitSample: function(upc, cards, deck, subject) {
        return postJSON(`/api/product/submit-sample/${upc}`, {
            cards: cards.map((card) =>
                Object.assign({}, { card_id: card })),
            deck_code: deck,
            question: subject,
        });
    },
    submitMandala: function(cards, deck, subject, upc, upgrade_slug) {
        const orderInfo = {
            cards: cards,
            deck_code: deck,
            question: subject,
            upgrade_slug: upgrade_slug,
        };

        return postJSON(`/api/product/submit/${upc}`, JSON.stringify(orderInfo));
    },
    submit: function(cards, deck, subject, upc, upgrade_slug) {
        const orderInfo = {
            cards: cards.map((card) =>
                Object.assign({}, { card_id: card })),
            deck_code: deck,
            question: subject,
            upgrade_slug: upgrade_slug,
        };

        return postJSON(`/api/product/submit/${upc}`, JSON.stringify(orderInfo));
    },
};



// WEBPACK FOOTER //
// ./app/config.js